// Terminos.js
import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Terminos.css';

const Terminos = () => {
  const navigate = useNavigate();

  return (
    <div className="terminos-container">
      <Container>
        <div className="terminos-header">
          <h1>Términos y Condiciones</h1>
          <Button 
            variant="primary" 
            className="volver-btn"
            onClick={() => navigate('/')}
          >
            ← Volver al Inicio
          </Button>
        </div>
        
        <div className="terminos-content">
          <div className="terminos-text">
            <h2>CONTRATO DE SERVICIOS EDUCATIVOS</h2>
            <p className="contract-parties"><strong>ENTRE:</strong></p>
            <p className="contract-parties"><strong>(1) ACADEMIA PIXEL</strong>, emprendimiento registrado en el programa "Emprender Juntos" del Gobierno de Venezuela (Registro N° CRNE2024/46002), con domicilio operativo en la plataforma digital <strong>https://certificadosapp-63ae1.web.app</strong>, en adelante denominada <strong>"El Proveedor"</strong>; y</p>
            <p className="contract-parties"><strong>(2) El Cliente</strong>, que acepta este contrato a través de la plataforma digital antes mencionada, en adelante denominado <strong>"El Cliente"</strong>.</p>

            <h3 className="section-title">SE ACUERDA LO SIGUIENTE:</h3>

            <div className="contract-section">
              <h4>1. SERVICIOS</h4>
              <p>El Proveedor se compromete a prestar los servicios educativos del curso <strong>"Diseño Digital Integral: IA, Ciberciudadanía y Herramientas Técnicas"</strong>, estructurado en cuatro pilares formativos:</p>
              <ol>
                <li><strong>Inteligencia Artificial aplicada a la educación</strong> (técnicas de prompting, creación de guiones persuasivos con IA)</li>
                <li><strong>Netiqueta y ciberciudadanía</strong> (ética, responsabilidad legal y gestión de contenidos en redes sociales)</li>
                <li><strong>Herramientas técnicas</strong> (configuración de redes sociales, HTML básico, ofimática, programas de diseño con software libre y comercial)</li>
                <li><strong>Comunicación efectiva</strong> (manejo del miedo escénico, storytelling con IA y estrategias de persuasión digital)</li>
              </ol>
              
              <h5>Funciones del facilitador:</h5>
              <ul>
                <li>Impartir sesiones híbridas o semi-presenciales mediante sistemas LMS (Learning Management System)</li>
                <li>Entregar al estudiante una planificación detallada del curso (duración: 1 mes y medio)</li>
                <li>Elaborar un informe descriptivo del desempeño del estudiante para su certificado final</li>
                <li>Brindar soporte para <strong>clases presenciales adicionales</strong>, sujetas a disponibilidad y costo extra (previo acuerdo)</li>
              </ul>
            </div>

            <div className="contract-section">
              <h4>2. PRECIO Y PAGO</h4>
              <ul>
                <li><strong>Costo total del curso:</strong> Determinado según la tasa del Banco Central de Venezuela vigente al momento de la contratación</li>
                <li><strong>Reserva no reembolsable:</strong> $2 USD para garantizar la inscripción. Este monto cubre gastos administrativos y de gestión del expediente estudiantil</li>
                <li><strong>Opciones de pago:</strong>
                  <ul>
                    <li><strong>Pago único</strong> al inicio del curso</li>
                    <li><strong>Abonos semanales</strong> después de cancelar la reserva</li>
                  </ul>
                </li>
                <li><strong>Política de cancelación:</strong>
                  <ul>
                    <li>Si el Cliente decide no tomar el curso, podrá aplicar su reserva a una futura edición <strong>solo si notifica por escrito dentro de los primeros 5 días hábiles posteriores al inicio del curso</strong></li>
                    <li>Si no comunica su decisión en dicho plazo, perderá el derecho a la reserva y no podrá transferirla a otras ofertas</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="contract-section">
              <h4>3. REQUISITOS TÉCNICOS Y EDAD MÍNIMA</h4>
              <ul>
                <li><strong>Edad mínima:</strong> 14 años o cursantes de 9° grado (tercer año de educación media)</li>
                <li><strong>Equipos obligatorios:</strong>
                  <ul>
                    <li>Celular con sistema operativo Android 13 o superior</li>
                    <li>Acceso estable a internet para seguimiento en línea</li>
                    <li>Computadora para ejecutar programas especializados</li>
                    <li>Memoria USB de 32 GB o superior para almacenamiento de materiales</li>
                  </ul>
                </li>
                <li><strong>Carnet de identificación:</strong> Deberá ser presentado en reuniones presenciales realizadas en recintos educativos o espacios autorizados</li>
              </ul>
            </div>

            <div className="contract-section">
              <h4>4. CERTIFICACIÓN</h4>
              <ul>
                <li><strong>Certificado de participación:</strong> Emitido al finalizar el curso, acredita asistencia y cumplimiento de actividades. <strong>No constituye título académico ni especializado</strong></li>
                <li><strong>Verificación digital:</strong> Disponible en la plataforma <strong>https://certificadosapp-63ae1.web.app</strong> para validación de habilidades adquiridas</li>
              </ul>
            </div>

            <div className="contract-section">
              <h4>5. TÉRMINOS Y CONDICIONES</h4>
              <ul>
                <li><strong>Plataforma digital:</strong> Todos los términos complementarios del curso se detallan en la plataforma. Es responsabilidad del Cliente revisarlos antes de iniciar</li>
                <li><strong>Licencias de contenido:</strong> Material educativo bajo licencias <strong>Creative Commons</strong> y <strong>YouTube Estándar</strong>. Prohibido su uso comercial no autorizado</li>
                <li><strong>Compromiso del estudiante:</strong>
                  <ul>
                    <li>Utilizar los recursos exclusivamente con fines educativos</li>
                    <li>Respetar los plazos de entrega de actividades y proyectos</li>
                  </ul>
                </li>
                <li><strong>Modificaciones:</strong> El Proveedor se reserva el derecho de actualizar términos, notificando cambios mediante la plataforma</li>
              </ul>
            </div>

            <div className="contract-section">
              <h4>6. LEY APLICABLE</h4>
              <p>Este contrato se rige por el <strong>Decreto N° 1.204 (Ley de Mensaje de Datos y Firmas Electrónicas)</strong> de Venezuela. Cualquier disputa se resolverá bajo las leyes venezolanas.</p>
            </div>

            <div className="signature-section">
              <p><strong>FIRMADO por las partes a través de la plataforma digital https://certificadosapp-63ae1.web.app</strong></p>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Terminos;